import { chakra } from '@chakra-ui/react'
import { SVGProps } from 'react'

export const UploadBackgroundIllustration = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      width={2697 / 3}
      height={869 / 3}
      viewBox="0 80 2697 435" //Show only top half
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2570.36 429.792C2567.36 431.057 2563.97 432.483 2562.49 439.856C2561.26 446.019 2557.54 470.797 2553.16 500.04C2547.11 540.382 2539.78 589.221 2535.95 609.412L2538.97 775.302L2521.09 786.3L2507.95 609.412H2388.99L2363.02 786.3L2341 776.83C2347.5 716.918 2362.49 604.449 2365.14 591.387C2365.37 590.236 2428.63 590.85 2458.14 591.2C2466.96 591.304 2474.75 585.655 2477.62 577.31C2498.91 515.558 2545.7 409.048 2575.93 420.914C2575.93 427.447 2573.34 428.54 2570.36 429.792ZM2554.55 445.978L2530.41 558.088C2528.99 564.3 2516.97 587.733 2509.03 582.234C2501.09 576.734 2508.11 553.505 2512.39 543.118C2513.25 541.026 2515.15 535.6 2517.71 528.315C2527.83 499.433 2548.21 441.334 2554.55 445.978Z"
        fill="#992A2A"
      />
      <path
        d="M2562.49 439.856L2561.32 439.621L2561.32 439.621L2562.49 439.856ZM2570.36 429.792L2569.9 428.687L2569.9 428.687L2570.36 429.792ZM2553.16 500.04L2551.97 499.863L2551.97 499.863L2553.16 500.04ZM2535.95 609.412L2534.77 609.188C2534.75 609.269 2534.75 609.351 2534.75 609.434L2535.95 609.412ZM2538.97 775.302L2539.6 776.323C2539.96 776.101 2540.17 775.704 2540.17 775.28L2538.97 775.302ZM2521.09 786.3L2519.89 786.389C2519.93 786.806 2520.17 787.177 2520.54 787.368C2520.92 787.558 2521.36 787.54 2521.72 787.321L2521.09 786.3ZM2507.95 609.412L2509.15 609.323C2509.1 608.697 2508.58 608.213 2507.95 608.213V609.412ZM2388.99 609.412V608.213C2388.39 608.213 2387.89 608.649 2387.8 609.238L2388.99 609.412ZM2363.02 786.3L2362.54 787.401C2362.89 787.549 2363.28 787.528 2363.6 787.347C2363.93 787.165 2364.15 786.843 2364.2 786.474L2363.02 786.3ZM2341 776.83L2339.81 776.7C2339.75 777.224 2340.04 777.723 2340.53 777.931L2341 776.83ZM2365.14 591.387L2366.31 591.625L2366.31 591.625L2365.14 591.387ZM2458.14 591.2L2458.15 590.001L2458.15 590.001L2458.14 591.2ZM2477.62 577.31L2478.76 577.7L2478.76 577.7L2477.62 577.31ZM2575.93 420.914H2577.13C2577.13 420.421 2576.83 419.979 2576.37 419.799L2575.93 420.914ZM2530.41 558.088L2531.58 558.356C2531.58 558.351 2531.58 558.346 2531.59 558.341L2530.41 558.088ZM2554.55 445.978L2555.72 446.23C2555.82 445.768 2555.64 445.29 2555.26 445.011L2554.55 445.978ZM2509.03 582.234L2509.71 581.248L2509.71 581.248L2509.03 582.234ZM2512.39 543.118L2513.5 543.574L2513.5 543.574L2512.39 543.118ZM2517.71 528.315L2516.58 527.918L2516.58 527.918L2517.71 528.315ZM2563.67 440.091C2564.37 436.566 2565.51 434.6 2566.71 433.372C2567.93 432.129 2569.31 431.534 2570.83 430.896L2569.9 428.687C2568.41 429.314 2566.59 430.065 2565 431.694C2563.38 433.339 2562.09 435.773 2561.32 439.621L2563.67 440.091ZM2554.34 500.218C2558.73 470.947 2562.44 446.216 2563.67 440.091L2561.32 439.621C2560.08 445.821 2556.35 470.647 2551.97 499.863L2554.34 500.218ZM2537.12 609.636C2540.97 589.415 2548.3 540.544 2554.34 500.218L2551.97 499.863C2545.92 540.22 2538.6 589.027 2534.77 609.188L2537.12 609.636ZM2540.17 775.28L2537.14 609.39L2534.75 609.434L2537.77 775.324L2540.17 775.28ZM2521.72 787.321L2539.6 776.323L2538.34 774.281L2520.46 785.279L2521.72 787.321ZM2506.76 609.501L2519.89 786.389L2522.29 786.211L2509.15 609.323L2506.76 609.501ZM2388.99 610.611H2507.95V608.213H2388.99V610.611ZM2364.2 786.474L2390.17 609.586L2387.8 609.238L2361.83 786.126L2364.2 786.474ZM2340.53 777.931L2362.54 787.401L2363.49 785.199L2341.47 775.728L2340.53 777.931ZM2363.96 591.15C2361.31 604.275 2346.31 716.798 2339.81 776.7L2342.19 776.959C2348.69 717.037 2363.68 604.624 2366.31 591.625L2363.96 591.15ZM2458.15 590.001C2443.4 589.826 2420.2 589.585 2400.66 589.532C2390.89 589.505 2382.03 589.526 2375.6 589.625C2372.38 589.674 2369.76 589.744 2367.93 589.837C2367.01 589.884 2366.28 589.938 2365.75 590.002C2365.49 590.033 2365.25 590.071 2365.04 590.123C2364.95 590.148 2364.8 590.19 2364.65 590.264C2364.58 590.301 2364.46 590.369 2364.34 590.482C2364.22 590.593 2364.03 590.811 2363.96 591.15L2366.31 591.625C2366.25 591.946 2366.07 592.146 2365.97 592.24C2365.86 592.335 2365.77 592.385 2365.73 592.406C2365.65 592.446 2365.6 592.454 2365.64 592.446C2365.69 592.433 2365.81 592.409 2366.04 592.382C2366.48 592.328 2367.15 592.278 2368.05 592.232C2369.84 592.14 2372.43 592.071 2375.63 592.022C2382.05 591.923 2390.89 591.903 2400.66 591.93C2420.18 591.983 2443.37 592.224 2458.12 592.398L2458.15 590.001ZM2476.49 576.919C2473.78 584.791 2466.44 590.099 2458.15 590.001L2458.12 592.398C2467.48 592.509 2475.72 586.519 2478.76 577.7L2476.49 576.919ZM2576.37 419.799C2572.22 418.169 2567.84 418.607 2563.41 420.602C2559 422.586 2554.49 426.131 2549.95 430.828C2540.87 440.224 2531.46 454.464 2522.37 470.926C2504.19 503.87 2487.14 546.005 2476.49 576.919L2478.76 577.7C2489.38 546.862 2506.38 504.866 2524.47 472.084C2533.52 455.683 2542.81 441.661 2551.67 432.494C2556.1 427.91 2560.37 424.598 2564.4 422.788C2568.39 420.988 2572.09 420.693 2575.5 422.03L2576.37 419.799ZM2570.83 430.896C2572.27 430.29 2573.95 429.606 2575.19 428.093C2576.46 426.548 2577.13 424.324 2577.13 420.914H2574.74C2574.74 424.037 2574.11 425.626 2573.34 426.574C2572.53 427.554 2571.43 428.042 2569.9 428.687L2570.83 430.896ZM2531.59 558.341L2555.72 446.23L2553.38 445.726L2529.24 557.836L2531.59 558.341ZM2508.35 583.219C2510.91 584.997 2513.73 584.301 2516.19 582.65C2518.64 581.007 2521.03 578.257 2523.15 575.242C2525.28 572.206 2527.19 568.809 2528.67 565.779C2530.13 562.771 2531.2 560.044 2531.58 558.356L2529.25 557.82C2528.92 559.238 2527.95 561.77 2526.51 564.731C2525.08 567.67 2523.23 570.953 2521.18 573.864C2519.13 576.796 2516.94 579.261 2514.85 580.659C2512.78 582.049 2511.11 582.22 2509.71 581.248L2508.35 583.219ZM2511.28 542.662C2509.12 547.909 2506.26 556.403 2504.94 564.312C2504.29 568.261 2504 572.135 2504.41 575.412C2504.82 578.665 2505.95 581.56 2508.35 583.219L2509.71 581.248C2508.14 580.158 2507.16 578.087 2506.79 575.113C2506.42 572.164 2506.67 568.549 2507.31 564.706C2508.59 557.028 2511.38 548.714 2513.5 543.574L2511.28 542.662ZM2516.58 527.918C2514.01 535.227 2512.13 540.608 2511.28 542.662L2513.5 543.574C2514.38 541.444 2516.29 535.972 2518.84 528.712L2516.58 527.918ZM2555.26 445.011C2554.49 444.452 2553.62 444.401 2552.8 444.69C2552.05 444.956 2551.35 445.503 2550.71 446.156C2549.41 447.474 2547.99 449.591 2546.5 452.233C2543.5 457.548 2540.02 465.336 2536.44 474.122C2529.27 491.709 2521.64 513.483 2516.58 527.918L2518.84 528.712C2523.9 514.264 2531.52 492.548 2538.66 475.026C2542.23 466.257 2545.66 458.587 2548.58 453.411C2550.05 450.809 2551.35 448.922 2552.41 447.839C2552.95 447.292 2553.35 447.039 2553.6 446.95C2553.79 446.884 2553.81 446.923 2553.84 446.945L2555.26 445.011Z"
        fill="black"
      />
      <path
        d="M2362.99 608.949L2534.95 608.949"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinecap="round"
      />
      <path
        d="M2521 785.9C2520.43 781.911 2524.77 770.416 2530.76 770.92C2536.74 771.424 2536.6 773.341 2537.95 773.971"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinejoin="round"
      />
      <path
        d="M2527.95 770.902C2526.84 725.916 2525.77 627.515 2520.95 612.946"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinejoin="round"
      />
      <path
        d="M2342 775.635C2345.08 774.206 2351.75 771.778 2353.81 773.492C2355.86 775.206 2359.45 781.144 2360.99 783.899"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinejoin="round"
      />
      <path
        d="M2374.49 609.948C2370.99 633.039 2360.99 718.515 2353 772.402"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinejoin="round"
      />
      <path
        d="M2553.47 470.01L2549.36 491.981"
        stroke="black"
        strokeWidth="1.59829"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2548.4 497.17L2544.28 519.142"
        stroke="black"
        strokeWidth="1.59829"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2543.06 525.759L2538.95 547.73"
        stroke="black"
        strokeWidth="1.59829"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2546.44 454.992C2549.94 447.994 2560.94 432.998 2567.94 430.998"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinejoin="round"
      />
      <path
        d="M2509.95 619.946L2534.95 610.948H2509.95V619.946Z"
        fill="black"
        stroke="black"
        strokeWidth="2.39744"
        strokeLinecap="round"
      />
      <path
        d="M2387.6 615.947L2361.99 608.949H2388.99L2387.6 615.947Z"
        fill="black"
      />
      <path
        d="M2155.13 755.39C2161.67 755.39 2172.79 744.944 2180.33 735.693H2204.24V770.61C2196.91 770.311 2180.33 770.61 2160.94 770.61C2132.5 770.61 2146.08 755.39 2155.13 755.39Z"
        fill="#F4ACAC"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2201.25 756.66C2208.53 756.66 2220.92 747.051 2229.31 738.539H2255.94L2259.81 770.663C2251.66 770.388 2229.31 770.663 2207.72 770.663C2185.81 770.663 2191.17 756.66 2201.25 756.66Z"
        fill="#F4ACAC"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2465.97 577.902C2478.38 536.486 2460.8 512.326 2450.46 505.424L2376.79 498.028C2346.59 512.991 2244.31 520.07 2225.57 559.207C2203.87 604.526 2202.95 681.597 2168.7 733.542L2202.95 739.235L2197.78 747.062L2280.5 754.889C2283.48 671.336 2291.4 613.059 2313.46 606.171C2356.75 592.651 2450.46 613.998 2465.97 577.902Z"
        fill="#F4ACAC"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2422.67 527.611C2425.26 539.444 2435.08 560.892 2453.69 552.017"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2202.95 739.234L2195.84 737.828C2195.84 737.828 2221.08 686.578 2226.86 631.075C2234.6 588.473 2245.22 578.518 2255.87 573.47C2255.92 573.448 2255.94 573.437 2255.94 573.437C2255.92 573.448 2255.9 573.459 2255.87 573.47C2254.46 574.155 2231.87 586.047 2226.86 646.018C2221.69 707.925 2202.95 739.234 2202.95 739.234Z"
        fill="black"
      />
      <path
        d="M2397.47 539.282C2371.8 547.858 2284.38 556.36 2255.94 573.437M2255.94 573.437C2255.94 573.437 2232.03 584.111 2226.86 646.018C2221.69 707.925 2202.95 739.234 2202.95 739.234L2195.84 737.828C2195.84 737.828 2221.08 686.578 2226.86 631.075C2234.62 588.381 2245.27 578.475 2255.94 573.437Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2417.96 341.619C2376.6 345.497 2361.53 334.941 2350.11 330.633C2348.99 348.747 2335.24 365.961 2330.07 373.285C2346.1 378.972 2380.7 376.947 2395.99 375.224C2369.11 420.202 2360.66 474.098 2359.8 502.533C2385.18 502.533 2404.53 505.678 2430.42 509.66C2455.62 513.538 2466 507.057 2477.42 504.472C2465.01 497.751 2461.26 453.634 2461.26 426.923C2469.02 422.399 2488.4 419.168 2501.33 415.937C2493.06 385.434 2462.55 348.513 2448.34 333.864L2417.96 341.619Z"
        fill="#EE8080"
      />
      <path
        d="M2461.26 426.923C2469.02 422.399 2488.4 419.168 2501.33 415.937C2493.06 385.434 2462.55 348.513 2448.34 333.864L2417.96 341.619C2376.6 345.497 2361.53 334.941 2350.11 330.633C2348.99 348.747 2335.24 365.961 2330.07 373.285C2346.1 378.972 2380.7 376.947 2395.99 375.224M2461.26 426.923C2461.26 453.634 2465.01 497.751 2477.42 504.472C2466 507.057 2455.62 513.538 2430.42 509.66C2404.53 505.678 2385.18 502.533 2359.8 502.533C2360.66 474.098 2369.11 420.202 2395.99 375.224M2461.26 426.923L2448.34 433.385C2448.34 409.493 2448.34 388.167 2445.75 369.408M2395.99 375.224C2398.07 371.605 2402.85 366.41 2405.22 363.61"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2365.62 502.533C2358.9 482.887 2370.57 443.294 2374.67 423.045C2367.94 443.208 2360.66 481.638 2359.16 502.533H2365.62Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2328.78 372.639C2326.2 372.122 2325.88 363.376 2326.96 358.421C2329.54 359.068 2336.72 355.855 2339.95 356.502C2338.01 361.025 2331.37 373.156 2328.78 372.639Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2500.86 415.956C2496.34 423.71 2479.54 450.852 2448.52 433.434C2465.32 423.064 2488.58 415.309 2500.86 415.956Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2315.21 308.661C2316.76 317.45 2337.83 326.54 2349.46 330.633C2349.46 344.592 2340.41 354.975 2335.89 359.068C2328.13 359.068 2293.89 343.558 2290.65 325.463C2288.84 315.284 2291.08 253.515 2294.53 225.942C2288.71 221.418 2292.59 210.432 2294.53 205.262C2296.08 201.126 2305.09 205.262 2309.39 207.847C2315.86 196.215 2328.67 199.209 2324.9 202.031C2317.15 207.847 2316.72 216.464 2315.21 222.711C2309.39 226.588 2313.27 297.675 2315.21 308.661Z"
        fill="#D98F6F"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2315.21 308.661C2316.76 317.45 2337.83 326.54 2349.46 330.633C2349.46 344.592 2340.41 354.975 2335.89 359.068C2328.13 359.068 2293.89 343.558 2290.65 325.463C2288.84 315.284 2291.08 253.515 2294.53 225.942C2288.71 221.418 2292.59 210.432 2294.53 205.262C2296.08 201.126 2305.09 205.262 2309.39 207.847C2315.86 196.215 2328.67 199.209 2324.9 202.031C2317.15 207.847 2316.56 216.427 2315.21 222.711C2314.1 227.9 2313.27 297.675 2315.21 308.661Z"
        fill="#D98F6F"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinejoin="round"
      />
      <path
        d="M2388.41 431.465C2388.41 426.941 2397.93 422.014 2405.04 421.125C2424.07 418.746 2456.97 438.451 2464.49 439.278C2465.32 439.649 2467.04 436.868 2462.55 428.861C2473.41 423.692 2491.63 416.999 2497.45 416.568C2502.62 423.677 2523.48 479.287 2507.97 487.688C2484.7 497.381 2423.96 435.975 2419.43 441.805C2419.43 459.22 2414.91 462.303 2412.79 463.097C2408.66 464.648 2405.22 461.192 2405.86 459.253C2405.22 461.192 2400.51 463.744 2397.28 462.451C2394.05 461.159 2392.94 459.22 2394.88 456.668C2389.06 461.838 2382.81 455.882 2385.47 454.05C2392.4 449.284 2393.86 437.244 2396.61 432.446C2392.99 437.388 2388.41 438.014 2388.41 431.465Z"
        fill="#D98F6F"
      />
      <path
        d="M2394.88 456.668C2389.06 461.838 2382.81 455.882 2385.47 454.05C2392.94 448.914 2394.05 435.328 2397.28 431.465C2393.58 437.281 2388.41 438.425 2388.41 431.465C2388.41 426.941 2397.93 422.014 2405.04 421.125C2424.07 418.746 2456.97 438.451 2464.49 439.278M2394.88 456.668C2392.94 459.22 2394.05 461.159 2397.28 462.451C2400.51 463.744 2405.22 461.192 2405.86 459.253M2394.88 456.668C2394.88 456.668 2401.16 452.145 2401.16 441.805M2405.86 459.253C2405.22 461.192 2408.66 464.648 2412.79 463.097C2414.91 462.303 2419.43 459.22 2419.43 441.805C2423.96 435.975 2484.7 497.381 2507.97 487.688C2523.48 479.287 2502.62 423.677 2497.45 416.568C2491.63 416.999 2473.41 423.692 2462.55 428.861C2467.04 436.868 2465.32 439.649 2464.49 439.278M2405.86 459.253C2405.86 459.253 2411.03 454.05 2409.74 441.805M2497.45 454.05L2464.49 439.278"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2307.08 210.038C2306.12 212.695 2299.63 211.333 2295.27 209.743C2290.91 208.154 2290.59 206.238 2291.3 204.282C2292.01 202.325 2293.49 201.068 2297.85 202.658C2302.21 204.247 2308.05 207.381 2307.08 210.038Z"
        fill="#D98F6F"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2304.5 216.5C2303.53 219.157 2297.04 217.795 2292.68 216.206C2288.33 214.616 2288 212.701 2288.71 210.744C2289.43 208.787 2290.91 207.53 2295.27 209.12C2299.63 210.709 2305.47 213.843 2304.5 216.5Z"
        fill="#D98F6F"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2303.21 222.963C2302.24 225.62 2295.75 224.258 2291.39 222.668C2287.03 221.079 2286.71 219.163 2287.42 217.207C2288.14 215.25 2289.62 213.993 2293.98 215.582C2298.33 217.172 2304.18 220.305 2303.21 222.963Z"
        fill="#D98F6F"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2325.08 424.969L2310.87 360.379L2181.15 304.156L2206.35 424.969L2339.3 487.688L2444.64 472.145L2416.38 460.596C2416.38 460.596 2412.97 463.744 2411.68 463.777C2410.4 463.81 2404.66 462.505 2405.91 459.376C2405.93 459.329 2405.94 459.303 2405.94 459.303C2405.93 459.328 2405.92 459.352 2405.91 459.376C2405.68 459.897 2404.04 462.99 2398.11 461.805C2392.76 460.735 2394.5 457.472 2395.25 456.381C2395.43 456.167 2395.52 456.022 2395.52 456.022C2395.52 456.022 2395.41 456.155 2395.25 456.381C2394.49 457.278 2392.12 459.401 2387.95 457.315C2385.09 455.887 2386.05 453.726 2387.95 451.499C2389.49 449.693 2390.53 447.621 2390.53 447.621L2344.65 424.969H2325.08Z"
        fill="#909BE5"
      />
      <path
        d="M2325.08 424.969L2310.87 360.379L2181.15 304.156L2206.35 424.969L2339.3 487.688L2444.64 472.145L2416.38 460.596C2416.38 460.596 2412.97 463.744 2411.68 463.777C2410.39 463.811 2404.57 462.485 2405.94 459.303C2405.94 459.303 2404.57 463.097 2398.11 461.805C2391.65 460.513 2395.52 456.022 2395.52 456.022C2395.52 456.022 2393.12 459.9 2387.95 457.315C2385.09 455.887 2386.05 453.726 2387.95 451.499M2325.08 424.969H2344.65L2390.53 447.621M2325.08 424.969L2334.78 476.022M2390.53 447.621C2390.53 447.621 2389.49 449.693 2387.95 451.499M2390.53 447.621L2387.95 451.499"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2380.66 301.585V251.825C2380.66 251.825 2385.83 225.96 2417.5 225.314C2449.16 224.668 2452.39 250.517 2452.39 250.517C2452.39 262.895 2448.47 269.846 2443.62 273.614C2448.97 270.399 2457.06 267.855 2458.86 276.382C2460.92 286.205 2450.24 289.953 2444.64 290.599C2440.5 312.83 2444.64 329.158 2447.22 334.544C2442.05 344.884 2423.96 343.16 2415.56 341.006V324.85C2380.92 325.884 2380.66 313.218 2380.66 301.585Z"
        fill="#D98F6F"
      />
      <path
        d="M2380.66 251.825V301.585C2380.66 313.218 2380.92 325.884 2415.56 324.85V341.006C2423.96 343.16 2442.05 344.884 2447.22 334.544C2444.64 329.158 2440.5 312.83 2444.64 290.599C2450.24 289.953 2460.92 286.205 2458.86 276.382C2456.79 266.559 2446.36 271.428 2441.41 275.09C2447.22 271.792 2452.39 264.735 2452.39 250.517C2452.39 250.517 2449.16 224.668 2417.5 225.314C2385.83 225.96 2380.66 251.825 2380.66 251.825Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinejoin="round"
      />
      <path
        d="M2416.2 324.85C2420.73 324.644 2428.17 323.297 2430.18 319.571C2430.26 319.387 2430.34 319.208 2430.42 319.033C2430.35 319.218 2430.27 319.397 2430.18 319.571C2427.04 326.414 2420.23 339.352 2416.2 340.359V324.85Z"
        fill="black"
      />
      <path
        d="M2416.2 324.85C2420.94 324.634 2428.87 323.169 2430.42 319.033C2427.41 325.711 2420.34 339.325 2416.2 340.359V324.85Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2397.18 219.923C2384.26 219.923 2379.73 233.278 2379.09 239.956C2364.87 239.956 2357.37 258.439 2368.75 265.159C2380.12 271.88 2389.43 262.359 2392.66 256.758C2393.3 258.912 2396.28 262.833 2403 261.282C2409.72 259.731 2413.55 257.62 2414.63 256.758C2414.63 257.835 2415.92 260.636 2421.09 263.221C2426.26 265.806 2431.86 264.298 2434.02 263.221C2432.98 271.493 2438.76 275.284 2441.77 276.146C2443.93 272.914 2449.14 268.391 2452.76 276.146C2456.38 283.9 2446.94 289.717 2441.77 291.655C2441.77 291.655 2438.82 320.958 2445.65 337.538C2452.48 354.118 2464.03 355.855 2473.72 344.223C2476.52 345.731 2485.41 348.375 2494.76 340.992C2507.04 331.298 2495.41 321.174 2494.76 318.373C2496.49 315.788 2511.85 312.557 2508.62 294.462C2506.86 284.611 2501.23 282.399 2494.76 282.184C2496.49 275.937 2499.85 265.382 2491.81 253.103C2484.61 242.091 2471.93 242.541 2466.33 243.187C2466.54 236.94 2460.64 223.542 2445.65 219.923C2430.66 216.304 2419.58 222.723 2414.63 226.385C2414.2 224.231 2410.11 219.923 2397.18 219.923Z"
        fill="black"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2404.57 225.315C2398.11 222.73 2385.18 232.708 2385.18 242.117"
        stroke="#FFEDE1"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2409.42 287.396C2408.38 283.982 2404.77 282.058 2401.35 283.098C2397.94 284.138 2396.02 287.749 2397.06 291.163C2397.67 293.186 2399.19 294.685 2401.04 295.356"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2410.1 273.299C2412.31 270.609 2418.4 269.617 2421.14 274.6"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2396.51 272.189C2395.13 270.685 2390.82 269.926 2388.42 272.139"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2424.38 286.077C2425.02 291.247 2422.57 301.313 2415.33 305.449C2408.09 309.585 2400.46 308.049 2396.59 306.11"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2417.89 281.488C2417.55 282.894 2416.74 284.461 2414.55 284.259C2412.52 284.072 2411.45 282.331 2411.63 280.296"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2395.77 280.584C2395.5 282.004 2394.76 283.606 2392.57 283.504C2390.53 283.409 2389.38 281.719 2389.47 279.678"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1035.67 294.926H797.412C796.242 294.924 795.121 294.459 794.294 293.632C793.467 292.805 793.001 291.683 793 290.514V231.412C793.001 230.242 793.467 229.121 794.294 228.294C795.121 227.467 796.242 227.001 797.412 227H1035.67C1036.84 227.001 1037.96 227.467 1038.79 228.294C1039.61 229.121 1040.08 230.242 1040.08 231.412V290.514C1040.08 291.683 1039.61 292.805 1038.79 293.632C1037.96 294.459 1036.84 294.924 1035.67 294.926ZM797.412 228.765C796.71 228.766 796.037 229.045 795.541 229.541C795.045 230.037 794.766 230.71 794.765 231.412V290.514C794.766 291.215 795.045 291.888 795.541 292.385C796.037 292.881 796.71 293.16 797.412 293.161H1035.67C1036.37 293.16 1037.04 292.881 1037.54 292.385C1038.04 291.888 1038.32 291.215 1038.32 290.514V231.412C1038.32 230.71 1038.04 230.037 1037.54 229.541C1037.04 229.045 1036.37 228.766 1035.67 228.765L797.412 228.765Z"
        fill="#BFC8C8"
      />
      <path
        d="M834.432 276.668C844.358 276.668 852.405 268.621 852.405 258.695C852.405 248.769 844.358 240.722 834.432 240.722C824.506 240.722 816.459 248.769 816.459 258.695C816.459 268.621 824.506 276.668 834.432 276.668Z"
        fill="#D1D6F9"
      />
      <path
        d="M875.941 246.713C875.147 246.713 874.385 247.029 873.823 247.591C873.261 248.152 872.946 248.914 872.946 249.709C872.946 250.503 873.261 251.265 873.823 251.827C874.385 252.389 875.147 252.704 875.941 252.704H1017.16C1017.95 252.704 1018.71 252.389 1019.27 251.827C1019.84 251.265 1020.15 250.503 1020.15 249.709C1020.15 248.914 1019.84 248.152 1019.27 247.591C1018.71 247.029 1017.95 246.713 1017.16 246.713H875.941Z"
        fill="#E6E6E6"
      />
      <path
        d="M875.941 264.686C875.147 264.686 874.385 265.002 873.823 265.563C873.261 266.125 872.946 266.887 872.946 267.682C872.946 268.476 873.261 269.238 873.823 269.8C874.385 270.361 875.147 270.677 875.941 270.677H936.706C937.1 270.678 937.49 270.601 937.854 270.451C938.218 270.3 938.549 270.08 938.828 269.802C939.107 269.523 939.328 269.193 939.479 268.829C939.63 268.465 939.707 268.075 939.707 267.682C939.707 267.288 939.63 266.898 939.479 266.534C939.328 266.17 939.107 265.84 938.828 265.561C938.549 265.283 938.218 265.063 937.854 264.913C937.49 264.762 937.1 264.685 936.706 264.686H875.941Z"
        fill="#E6E6E6"
      />
      <path
        d="M624.304 533.107H518.412C517.242 533.105 516.121 532.64 515.294 531.813C514.467 530.986 514.001 529.864 514 528.695V418.412C514.001 417.242 514.467 416.121 515.294 415.294C516.121 414.467 517.242 414.001 518.412 414H624.304C625.474 414.001 626.596 414.467 627.423 415.294C628.25 416.121 628.715 417.242 628.717 418.412V528.695C628.715 529.864 628.25 530.986 627.423 531.813C626.596 532.64 625.474 533.105 624.304 533.107ZM518.412 415.765C517.71 415.766 517.037 416.045 516.541 416.541C516.045 417.037 515.766 417.71 515.765 418.412V528.695C515.766 529.397 516.045 530.069 516.541 530.566C517.037 531.062 517.71 531.341 518.412 531.342H624.304C625.006 531.341 625.679 531.062 626.176 530.566C626.672 530.069 626.951 529.397 626.952 528.695V418.412C626.951 417.71 626.672 417.037 626.176 416.541C625.679 416.045 625.006 415.766 624.304 415.765H518.412Z"
        fill="#BFC8C8"
      />
      <path
        d="M540.976 436.742C540.181 436.742 539.419 437.058 538.858 437.62C538.296 438.181 537.98 438.943 537.98 439.738C537.98 440.532 538.296 441.294 538.858 441.856C539.419 442.418 540.181 442.733 540.976 442.733H601.741C602.535 442.733 603.297 442.418 603.859 441.856C604.421 441.294 604.736 440.532 604.736 439.738C604.736 438.943 604.421 438.181 603.859 437.62C603.297 437.058 602.535 436.742 601.741 436.742H540.976Z"
        fill="#E6E6E6"
      />
      <path
        d="M540.976 454.391C540.582 454.39 540.192 454.467 539.828 454.617C539.463 454.768 539.133 454.988 538.854 455.266C538.575 455.545 538.354 455.875 538.203 456.239C538.052 456.603 537.975 456.992 537.975 457.386C537.975 457.78 538.052 458.17 538.203 458.534C538.354 458.898 538.575 459.228 538.854 459.506C539.133 459.785 539.463 460.005 539.828 460.155C540.192 460.306 540.582 460.383 540.976 460.382H601.741C602.535 460.382 603.297 460.066 603.859 459.504C604.421 458.943 604.736 458.181 604.736 457.386C604.736 456.592 604.421 455.83 603.859 455.268C603.297 454.706 602.535 454.391 601.741 454.391H540.976Z"
        fill="#E6E6E6"
      />
      <path
        d="M571.358 510.365C567.629 510.365 563.984 509.259 560.883 507.187C557.782 505.115 555.366 502.17 553.939 498.725C552.512 495.28 552.138 491.489 552.866 487.831C553.593 484.173 555.389 480.814 558.026 478.177C560.663 475.54 564.023 473.744 567.68 473.017C571.338 472.289 575.129 472.663 578.574 474.09C582.019 475.517 584.964 477.933 587.036 481.034C589.108 484.135 590.214 487.78 590.214 491.509C590.208 496.508 588.22 501.301 584.685 504.836C581.15 508.371 576.357 510.359 571.358 510.365Z"
        fill="#D1D6F9"
      />
      <path
        d="M392.769 379.143C399.885 379.143 405.654 373.373 405.654 366.257C405.654 359.14 399.885 353.371 392.769 353.371C385.652 353.371 379.883 359.14 379.883 366.257C379.883 373.373 385.652 379.143 392.769 379.143Z"
        fill="#BFC2C8"
      />
      <path
        d="M1435.21 530.937H1335.87L1359.25 490.445C1359.67 489.72 1360.27 489.117 1361 488.698C1361.72 488.279 1362.55 488.058 1363.39 488.058C1364.22 488.058 1365.05 488.279 1365.77 488.698C1366.5 489.117 1367.1 489.72 1367.52 490.445L1377.51 507.743L1394.49 478.332C1395.01 477.423 1395.77 476.669 1396.67 476.144C1397.58 475.62 1398.61 475.343 1399.66 475.343C1400.71 475.343 1401.74 475.62 1402.65 476.144C1403.56 476.669 1404.31 477.423 1404.84 478.332L1435.21 530.937Z"
        fill="#D1D6F9"
      />
      <path
        d="M1435.3 530.926H1329.41C1328.24 530.924 1327.12 530.459 1326.29 529.632C1325.47 528.805 1325 527.683 1325 526.514V467.412C1325 466.242 1325.47 465.121 1326.29 464.294C1327.12 463.467 1328.24 463.001 1329.41 463H1435.3C1436.47 463.001 1437.6 463.467 1438.42 464.294C1439.25 465.121 1439.72 466.242 1439.72 467.412V526.514C1439.72 527.683 1439.25 528.805 1438.42 529.632C1437.6 530.459 1436.47 530.924 1435.3 530.926ZM1329.41 464.765C1328.71 464.766 1328.04 465.045 1327.54 465.541C1327.04 466.037 1326.77 466.71 1326.76 467.412V526.514C1326.77 527.215 1327.04 527.888 1327.54 528.385C1328.04 528.881 1328.71 529.16 1329.41 529.161H1435.3C1436.01 529.16 1436.68 528.881 1437.18 528.385C1437.67 527.888 1437.95 527.215 1437.95 526.514V467.412C1437.95 466.71 1437.67 466.037 1437.18 465.541C1436.68 465.045 1436.01 464.766 1435.3 464.765H1329.41Z"
        fill="#BFC2C8"
      />
      <path
        d="M407.549 361.713C446.55 353.298 492.116 347.56 540.558 344.963C589.385 342.371 639.735 343.091 687.351 347.064C711.287 349.049 734.285 351.825 755.854 355.333C777.831 358.911 797.689 363.317 816.796 367.982C836.151 372.707 854.87 377.643 875.076 382.092C932.761 394.937 1004.38 401.955 1078.23 402C1084.33 402.003 1090.42 401.956 1096.51 401.859C1099.82 401.809 1099.84 400.371 1096.51 400.422C1021.24 401.577 946.899 395.319 886.514 382.744C865.572 378.382 846.451 373.394 826.93 368.561C808.004 363.875 788.571 359.316 767.099 355.551C714.578 346.334 653.477 341.629 591.419 342.023C529.361 342.417 469.093 347.893 418.134 357.767C413.289 358.706 408.556 359.686 403.899 360.696C401.282 361.264 404.957 362.275 407.549 361.713Z"
        fill="#BFC2C8"
      />
      <path
        d="M1313.67 427.224H1103.41C1102.24 427.223 1101.12 426.758 1100.29 425.931C1099.47 425.103 1099 423.982 1099 422.812V313.412C1099 312.242 1099.47 311.121 1100.29 310.294C1101.12 309.467 1102.24 309.001 1103.41 309H1313.67C1314.84 309.001 1315.96 309.467 1316.79 310.294C1317.61 311.121 1318.08 312.242 1318.08 313.412V422.812C1318.08 423.982 1317.61 425.103 1316.79 425.931C1315.96 426.758 1314.84 427.223 1313.67 427.224ZM1103.41 310.765C1102.71 310.766 1102.04 311.045 1101.54 311.541C1101.04 312.037 1100.77 312.71 1100.76 313.412V422.812C1100.77 423.514 1101.04 424.187 1101.54 424.683C1102.04 425.18 1102.71 425.459 1103.41 425.46H1313.67C1314.37 425.459 1315.04 425.18 1315.54 424.683C1316.04 424.187 1316.32 423.514 1316.32 422.812V313.412C1316.32 312.71 1316.04 312.037 1315.54 311.541C1315.04 311.045 1314.37 310.766 1313.67 310.765H1103.41Z"
        fill="#BFC8C8"
      />
      <path
        d="M1138.67 365.727C1148.59 365.727 1156.64 357.681 1156.64 347.755C1156.64 337.829 1148.59 329.782 1138.67 329.782C1128.74 329.782 1120.69 337.829 1120.69 347.755C1120.69 357.681 1128.74 365.727 1138.67 365.727Z"
        fill="#D1D6F9"
      />
      <path
        d="M1180.18 335.773C1179.78 335.772 1179.39 335.849 1179.03 335.999C1178.66 336.149 1178.33 336.37 1178.05 336.648C1177.78 336.926 1177.55 337.257 1177.4 337.621C1177.25 337.984 1177.18 338.374 1177.18 338.768C1177.18 339.162 1177.25 339.552 1177.4 339.916C1177.55 340.28 1177.78 340.61 1178.05 340.888C1178.33 341.167 1178.66 341.387 1179.03 341.537C1179.39 341.687 1179.78 341.764 1180.18 341.764H1293.39C1294.19 341.764 1294.95 341.448 1295.51 340.886C1296.07 340.325 1296.39 339.563 1296.39 338.768C1296.39 337.974 1296.07 337.212 1295.51 336.65C1294.95 336.088 1294.19 335.773 1293.39 335.773H1180.18Z"
        fill="#E6E6E6"
      />
      <path
        d="M1180.18 353.746C1179.78 353.745 1179.39 353.822 1179.03 353.972C1178.66 354.122 1178.33 354.343 1178.05 354.621C1177.78 354.899 1177.55 355.23 1177.4 355.593C1177.25 355.957 1177.18 356.347 1177.18 356.741C1177.18 357.135 1177.25 357.525 1177.4 357.889C1177.55 358.252 1177.78 358.583 1178.05 358.861C1178.33 359.139 1178.66 359.36 1179.03 359.51C1179.39 359.66 1179.78 359.737 1180.18 359.737H1240.94C1241.74 359.737 1242.5 359.421 1243.06 358.859C1243.62 358.297 1243.94 357.535 1243.94 356.741C1243.94 355.947 1243.62 355.185 1243.06 354.623C1242.5 354.061 1241.74 353.746 1240.94 353.746H1180.18Z"
        fill="#E6E6E6"
      />
      <path
        d="M1124.88 382.479C1122.6 382.479 1120.75 383.823 1120.75 385.474C1120.75 387.126 1122.6 388.47 1124.88 388.47H1291.72C1293.99 388.47 1295.85 387.126 1295.85 385.474C1295.85 383.823 1293.99 382.479 1291.72 382.479H1124.88Z"
        fill="#E6E6E6"
      />
      <path
        d="M1124.88 400.452C1122.6 400.452 1120.75 401.796 1120.75 403.447C1120.75 405.099 1122.6 406.443 1124.88 406.443H1291.72C1293.99 406.443 1295.85 405.099 1295.85 403.447C1295.85 401.796 1293.99 400.452 1291.72 400.452H1124.88Z"
        fill="#E6E6E6"
      />
      <path
        d="M308.897 785.948C302.358 785.948 291.233 777.32 283.693 769.678H259.783L259.783 798.521H303.081C322.757 798.521 317.945 785.948 308.897 785.948Z"
        fill="#D1D6F9"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M284.991 788.564C278.452 788.564 267.974 777.705 260.435 770.063H236.524L231.354 799.237C238.678 798.991 266.251 799.237 281.114 799.237C300.79 799.237 294.039 788.564 284.991 788.564Z"
        fill="#D1D6F9"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.574 521.902C214.166 480.486 231.744 456.326 242.084 449.424L315.755 442.028C321.571 499.715 307.354 605.475 307.354 605.475C307.354 605.475 290.552 764.484 295.076 771.88L275.688 769.661L267.287 771.88L220.368 774.332C242.084 627.748 228.298 568.742 226.574 521.902Z"
        fill="#D1D6F9"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M269.872 471.611C267.287 483.444 257.464 504.892 238.852 496.017"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M275.689 768.922L288.613 598.819L268.58 770.401L275.689 768.922Z"
        fill="black"
      />
      <path
        d="M295.075 468.653C300.245 531.517 288.613 598.819 288.613 598.819M288.613 598.819L275.689 768.922L268.58 770.401L288.613 598.819Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M278.708 285.619C320.067 289.497 335.146 278.942 346.563 274.633C350.182 291.177 361.426 309.961 366.596 317.285C350.569 322.972 315.974 320.947 300.68 319.224C327.563 364.202 336.008 418.099 336.869 446.533C316.836 439.424 280.646 443.302 267.075 449.764C256.218 454.934 230.67 451.057 219.254 448.472C231.661 441.751 235.41 397.634 235.41 370.923C227.655 366.399 208.268 363.168 195.343 359.937C203.615 329.434 234.117 292.513 248.334 277.865L278.708 285.619Z"
        fill="#6D7CDC"
      />
      <path
        d="M235.41 370.923C227.655 366.399 208.267 363.168 195.343 359.937C203.615 329.434 234.117 292.513 248.334 277.865L278.708 285.619C320.067 289.497 335.146 278.942 346.563 274.633C350.182 291.177 361.426 309.961 366.596 317.285C350.569 322.972 315.974 320.947 300.68 319.224M235.41 370.923C235.41 397.634 231.661 441.751 219.254 448.472C230.67 451.057 256.218 454.934 267.075 449.764C280.646 443.302 316.836 439.424 336.869 446.533C336.008 418.099 327.563 364.202 300.68 319.224M235.41 370.923L248.334 377.385C248.334 353.493 248.334 332.167 250.919 313.408M300.68 319.224C298.6 315.605 293.818 310.411 291.454 307.61"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M328.467 443.948C335.188 424.302 326.098 387.294 322.005 367.045C328.726 387.208 336.007 425.638 337.515 446.533L328.467 443.948Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M367.888 316.639C370.473 316.122 370.793 307.376 369.716 302.422C367.131 303.068 362.607 303.714 359.376 304.36C361.315 308.884 365.304 317.156 367.888 316.639Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.691 360.695C208.234 369.101 229.588 387.711 247.683 378.708C230.902 372.103 196.811 359.254 194.691 360.695Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M381.461 252.661C379.91 261.45 358.842 270.54 347.21 274.633C347.21 288.592 356.258 298.975 360.781 303.068C368.536 303.068 402.786 287.558 406.018 269.463C407.836 259.284 405.587 197.515 402.141 169.942C405.377 167.425 410.362 144.758 394.206 149.281C394.206 135.71 392.267 126.017 389.036 128.602C386.86 130.342 385.464 142.187 385.805 149.474C384.293 150.523 382.185 152.343 379.343 155.098C375.341 158.975 379.343 160.268 381.461 166.711C385.159 171.9 383.4 241.675 381.461 252.661Z"
        fill="#F5B896"
      />
      <path
        d="M347.21 274.633C358.842 270.54 379.91 261.45 381.461 252.661C383.4 241.675 385.159 171.9 381.461 166.711C379.343 160.268 375.341 158.975 379.343 155.098C390.681 144.112 390.329 147.989 387.097 156.39C388.767 153.766 390.975 146.05 385.805 149.474C385.464 142.187 386.86 130.342 389.036 128.602C392.267 126.017 394.206 135.71 394.206 149.281C410.362 144.758 405.377 167.425 402.141 169.942C405.587 197.515 407.836 259.284 406.018 269.463C402.786 287.558 368.536 303.068 360.781 303.068C356.258 298.975 347.21 288.592 347.21 274.633Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinejoin="round"
      />
      <path
        d="M334.205 305.294L334.201 305.299L334.196 305.305C323.47 318.115 308.464 338.703 298.306 358.817C293.225 368.878 289.39 378.756 287.883 387.444C286.406 395.959 287.197 403.122 290.984 408.244L343.936 419.899C342.595 411.464 342.797 400.23 349.573 386.981C356.826 372.796 371.559 356.409 399.749 338.674C400.832 337.789 401.992 336.637 402.941 335.361C403.914 334.053 404.612 332.687 404.84 331.397C405.06 330.152 404.85 328.969 403.975 327.871C403.065 326.73 401.345 325.568 398.319 324.631C390.203 322.121 387.02 319.013 384.932 316.223C384.562 315.729 384.239 315.27 383.941 314.845C382.569 312.894 381.701 311.659 379.078 311.035C375.57 310.201 371.18 310.491 366.972 310.907C366.404 310.963 365.839 311.022 365.281 311.08C363.809 311.232 362.386 311.379 361.108 311.464C359.366 311.58 357.722 311.597 356.457 311.296C355.249 311.009 353.36 310.174 351.312 309.257C351.129 309.175 350.944 309.093 350.758 309.009C348.784 308.124 346.588 307.14 344.406 306.304C342.004 305.384 339.708 304.68 337.82 304.475C335.874 304.263 334.758 304.618 334.205 305.294Z"
        fill="#FFFEFD"
        stroke="black"
        strokeWidth="2.45571"
      />
      <path
        d="M374.897 338.105L340.175 327.592"
        stroke="black"
        strokeWidth="2.19467"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M367.021 347.512L332.299 336.999"
        stroke="black"
        strokeWidth="2.19467"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M293.001 408.296L344.556 420.556C352.934 421.669 357.557 419.215 360.066 415.987C362.422 412.957 363.091 409.024 362.946 406.022L303.416 391.866C303.21 396.172 301.22 399.927 298.805 402.888C296.982 405.123 294.877 406.956 293.001 408.296Z"
        fill="#FFFEFD"
        stroke="black"
        strokeWidth="2.45571"
      />
      <path
        d="M195.63 435.223C218.895 444.917 276.767 395.132 283.697 389.328C302.617 390.608 317.943 378.032 320.533 373.508C322.959 369.271 319.24 368.417 316.395 369.669C318.792 367.887 321.433 365.1 320.533 362.522C319.385 359.237 317.302 359.805 315.162 360.932C320.172 353.373 314.717 353.005 311.486 354.767C304.377 358.645 301.792 359.805 297.915 359.805C299.207 354.002 301.063 350.122 295.33 352.058C291.044 353.504 280.377 364.78 279.174 371.842C261.725 380.151 239.755 394.852 233.292 397.437C234.585 394.852 241.047 376.093 241.047 376.093C241.047 376.093 224.891 364.104 206.149 364.104C200.979 371.212 180.12 426.822 195.63 435.223Z"
        fill="#F5B896"
      />
      <path
        d="M233.292 397.437C239.755 394.852 261.725 380.151 279.174 371.842C280.377 364.78 291.044 353.504 295.33 352.058C301.063 350.122 299.207 354.002 297.915 359.805C301.792 359.805 304.377 358.645 311.486 354.767C314.717 353.005 320.172 353.373 315.162 360.932M233.292 397.437C234.585 394.852 241.047 376.093 241.047 376.093C241.047 376.093 224.891 364.104 206.149 364.104C200.979 371.212 180.12 426.822 195.63 435.223C218.895 444.917 276.767 395.132 283.697 389.328C302.617 390.608 317.943 378.032 320.533 373.508C323.493 368.338 317.302 368.204 314.717 370.791M233.292 397.437L213.259 407.777M315.162 360.932C317.302 359.805 319.385 359.237 320.533 362.522C321.656 365.739 317.266 369.28 314.717 370.791M315.162 360.932C310.839 364.975 303.392 367.88 297.915 368.206M314.717 370.791C312.168 372.303 304.592 376.093 300.499 376.093"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M392.658 156.729C393.436 159.042 398.644 157.856 402.143 156.473C405.643 155.089 405.903 153.422 405.331 151.719C404.758 150.016 403.569 148.922 400.069 150.305C396.57 151.689 391.88 154.416 392.658 156.729Z"
        fill="#F5B896"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M393.696 162.354C394.473 164.667 399.682 163.481 403.181 162.098C406.68 160.714 406.941 159.047 406.368 157.344C405.795 155.641 404.606 154.547 401.107 155.93C397.607 157.314 392.918 160.041 393.696 162.354Z"
        fill="#F5B896"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M316.19 247.236V197.476H255.444C255.444 211.693 256.736 217.725 255.444 220.74C250.489 217.078 240.063 212.21 237.995 222.033C235.927 231.856 242.556 237.561 248.157 238.207C252.293 260.438 252.213 274.809 249.628 280.194C254.798 290.534 272.892 288.811 281.293 286.657V270.501C315.932 271.535 316.19 258.868 316.19 247.236Z"
        fill="#F5B896"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinejoin="round"
      />
      <path
        d="M280.647 270.501C276.119 270.295 268.681 268.949 266.674 265.222C266.59 265.038 266.509 264.859 266.43 264.685C266.499 264.869 266.581 265.048 266.674 265.222C269.813 272.065 276.619 285.004 280.647 286.011V270.501Z"
        fill="black"
      />
      <path
        d="M280.647 270.501C275.908 270.285 267.981 268.821 266.43 264.685C269.446 271.362 276.511 284.977 280.647 286.011V270.501Z"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M259.142 266.642C235.231 268.571 222.091 255.225 212.613 247.901C226.184 225.283 215.456 158.203 273.359 163.89C286.069 160.659 313.943 163.114 323.766 198.787C321.116 205.717 311.313 209.729 299.855 211.954C299.002 212.12 293.616 188.301 292.747 188.447C293.393 206.542 292.321 212.878 292.747 213.004C276.325 215.394 260.218 214.485 255.265 213.66V219.476C250.31 216.676 239.755 213.401 237.17 222.707C234.585 232.013 244.709 237.786 250.095 239.509C250.095 256.302 254.619 263.411 259.142 266.642Z"
        fill="black"
        stroke="black"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M287.577 170.352C295.762 172.076 312.78 179.529 315.365 195.556"
        stroke="white"
        strokeWidth="2.45571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M305.91 225.112C305.575 223.706 304.76 222.139 302.576 222.341C300.541 222.528 299.47 224.269 299.658 226.304"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M283.798 226.016C283.527 224.596 282.785 222.994 280.594 223.096C278.552 223.191 277.403 224.881 277.498 226.922"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M287.1 231.396C288.141 227.981 291.752 226.057 295.166 227.097C298.58 228.138 300.504 231.749 299.464 235.163C298.848 237.185 297.33 238.685 295.484 239.355"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M283.053 212.71C283.053 210.028 275.944 209.382 274.006 214.552"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M299.855 212.71C299.855 210.028 307.61 208.735 308.903 214.552"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M284.897 257.289C276.863 255.064 273.559 244.169 272.911 238.999C279.518 244.876 295.215 250.664 306.477 245.132C305.109 255.483 292.931 259.513 284.897 257.289Z"
        fill="black"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M288.644 253.668C292.771 251.018 296.74 253.165 298.209 254.57C287.322 260.006 281.854 254.061 280.481 250.41C283.606 248.015 287.225 251.584 288.644 253.668Z"
        fill="white"
      />
      <circle
        cx="279.822"
        cy="224.245"
        r="8.40111"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M311.893 224.245C311.893 228.885 308.131 232.646 303.491 232.646C302.093 232.646 300.774 232.304 299.614 231.7C299.614 231.7 299.614 230.342 298.322 228.769C297.111 227.295 295.496 226.83 295.496 226.83C295.232 226.016 295.09 225.147 295.09 224.245C295.09 219.605 298.852 215.844 303.491 215.844C308.131 215.844 311.893 219.605 311.893 224.245Z"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M254.618 217.783C258.496 219.937 267.026 224.245 270.128 224.245"
        stroke="black"
        strokeWidth="1.93872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2277.4 411.305L2260.89 379"
        stroke="black"
        strokeWidth="2.19467"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2260.42 379.376L2241.31 399.612"
        stroke="black"
        strokeWidth="2.19467"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2277.13 411.227L2241.3 399.993"
        stroke="black"
        strokeWidth="2.19467"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1726.86 316.71C1723.13 316.71 1719.48 315.604 1716.38 313.533C1713.28 311.461 1710.86 308.516 1709.44 305.071C1708.01 301.625 1707.63 297.834 1708.36 294.177C1709.09 290.519 1710.89 287.159 1713.52 284.523C1716.16 281.886 1719.52 280.09 1723.18 279.362C1726.83 278.635 1730.63 279.008 1734.07 280.435C1737.52 281.862 1740.46 284.279 1742.53 287.38C1744.6 290.48 1745.71 294.126 1745.71 297.855C1745.7 302.854 1743.72 307.647 1740.18 311.181C1736.65 314.716 1731.85 316.705 1726.86 316.71Z"
        fill="#D1D6F9"
      />
      <path
        d="M1780.3 381.107H1674.41C1673.24 381.105 1672.12 380.64 1671.29 379.813C1670.47 378.986 1670 377.864 1670 376.695V266.412C1670 265.242 1670.47 264.121 1671.29 263.294C1672.12 262.467 1673.24 262.001 1674.41 262H1780.3C1781.47 262.001 1782.6 262.467 1783.42 263.294C1784.25 264.121 1784.72 265.242 1784.72 266.412V376.695C1784.72 377.864 1784.25 378.986 1783.42 379.813C1782.6 380.64 1781.47 381.105 1780.3 381.107ZM1674.41 263.765C1673.71 263.766 1673.04 264.045 1672.54 264.541C1672.04 265.037 1671.77 265.71 1671.76 266.412V376.695C1671.77 377.397 1672.04 378.069 1672.54 378.566C1673.04 379.062 1673.71 379.341 1674.41 379.342H1780.3C1781.01 379.341 1781.68 379.062 1782.18 378.566C1782.67 378.069 1782.95 377.397 1782.95 376.695V266.412C1782.95 265.71 1782.67 265.037 1782.18 264.541C1781.68 264.045 1781.01 263.766 1780.3 263.765H1674.41Z"
        fill="#BFC8C8"
      />
      <path
        d="M1697 329C1696.2 329 1695.44 329.316 1694.88 329.877C1694.32 330.439 1694 331.201 1694 331.995C1694 332.79 1694.32 333.552 1694.88 334.114C1695.44 334.675 1696.2 334.991 1697 334.991H1757.76C1758.56 334.991 1759.32 334.675 1759.88 334.114C1760.44 333.552 1760.76 332.79 1760.76 331.995C1760.76 331.201 1760.44 330.439 1759.88 329.877C1759.32 329.316 1758.56 329 1757.76 329H1697Z"
        fill="#E6E6E6"
      />
      <path
        d="M1697 354C1696.61 353.999 1696.22 354.076 1695.85 354.226C1695.49 354.377 1695.16 354.597 1694.88 354.875C1694.6 355.154 1694.38 355.484 1694.23 355.848C1694.08 356.212 1694 356.602 1694 356.995C1694 357.389 1694.08 357.779 1694.23 358.143C1694.38 358.507 1694.6 358.837 1694.88 359.116C1695.16 359.394 1695.49 359.614 1695.85 359.765C1696.22 359.915 1696.61 359.992 1697 359.991H1757.77C1758.56 359.991 1759.32 359.675 1759.88 359.114C1760.45 358.552 1760.76 357.79 1760.76 356.995C1760.76 356.201 1760.45 355.439 1759.88 354.877C1759.32 354.316 1758.56 354 1757.77 354H1697Z"
        fill="#E6E6E6"
      />
      <path
        d="M1447.09 500.054C1503.86 494.91 1567.23 499.395 1620.73 504.136C1648.29 506.578 1675.55 509.184 1704.06 511.112C1728.05 512.73 1752.62 513.946 1777.54 514.75C1827.53 516.349 1878.38 516.414 1928.46 514.943C1978.8 513.476 2027.86 510.496 2074.12 506.095C2120.11 501.74 2162.63 495.933 2200.17 488.877C2204.95 487.976 2209.63 487.054 2214.22 486.111C2219.69 484.993 2211.3 483.241 2205.83 484.359C2169.68 491.721 2128.18 497.842 2082.86 502.494C2037.73 507.13 1989.6 510.36 1939.99 512.083C1890.21 513.836 1839.46 514.019 1789.43 512.626C1764.47 511.921 1739.82 510.801 1715.71 509.278C1688.03 507.396 1660.86 505.192 1634.35 502.676C1580.35 497.832 1520.35 493.087 1461.01 496.429C1454.21 496.821 1447.56 497.318 1441.11 497.914C1434.12 498.547 1440.15 500.683 1447.09 500.054Z"
        fill="#BFC8C8"
      />
      <path
        d="M2226.89 490.772C2234 490.772 2239.77 485.002 2239.77 477.886C2239.77 470.769 2234 465 2226.89 465C2219.77 465 2214 470.769 2214 477.886C2214 485.002 2219.77 490.772 2226.89 490.772Z"
        fill="#BFC8C8"
      />
    </svg>
  ),
)
